import React, { useState } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CButton,
  CProgress
} from "@coreui/react";
import { HiUserGroup } from "react-icons/hi";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import ConsolidatedFilter from "./filter";
import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import Charts from "../../../components/Charts";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import { arrayToCSV, elementToPDF } from "../../../utils/export";

const ConsolidatedPanel = props => {
  const token = useSelector(state => state.user.token);
  const userId = useSelector(state => state.user.user.id);
  const userRole = useSelector(state => state.user?.user_roles);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const getPercentage = abilityId => {
    if (!data.applications || !data.abilities) {
      return 0;
    }

    const correct =
      data.applications.find(
        item => item.ability_id === abilityId && item.correct
      )?.count || 0;
    const notCorrect =
      data.applications.find(
        item => item.ability_id === abilityId && !item.correct
      )?.count || 0;
    const total = correct + notCorrect;

    if (total === 0) {
      return 0;
    }

    return (correct / total) * 100;
  };
  const getCorrects = abilityId => {
    if (!data.applications || !data.abilities) {
      return "";
    }

    const correct = data.applications.find(
      item => item.ability_id === abilityId && item.correct
    )?.count;

    return correct || 0;
  };
  const getCSV = data => {
    const header = ["habilidade", "total_acertos", "porcentagem_acertos"];

    const arr = [header];

    data.forEach(ability => {
      arr.push([
        ability.description,
        getCorrects(ability.ability_id),
        getPercentage(ability.ability_id).toFixed(0)
      ]);
    });

    return arr;
  };
  const formatAbility = (ability, onlyCode) => {
    if (ability.code === null) return "(Sem habilidade)";
    if (onlyCode)
      return `(${ability.code}) - ${ability.description.substring(0, 30)}...`;
    return `(${ability.code})`;
  };
  const isAdmin = roles => {
    if (roles.filter(e => e.role_id === 1).length >= 1) return true;

    return false;
  };
  const onChangeFilter = params => {
    setLoading(true);
    axios
      .get(`${URL.api}statistics/evaluation_corrects_by_ability`, {
        params,
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        const data = resp.data.data;
        const applications = data.applications;

        const preAbilities = applications.map(e => ({
          code: e.ability_code,
          description: e.ability_description,
          ability_id: e.ability_id
        }));

        let abilities = [];

        preAbilities.forEach(ability => {
          if (abilities.filter(e => e.code === ability.code).length > 0) return;

          abilities.push(ability);
        });

        const dataFinal = {
          abilities,
          applications
        };
        setData(dataFinal);
        setLoading(false);
      });
  };
  const onClearFilter = () => setData([]);
  return (
    <>
      <Breadcrumb current={props.currentRoute} />
      <CCard>
        <CCardHeader>
          <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
            <h4 className="card-title mb-1">Painel Consolidado</h4>
            <div className="small text-muted">
              Monitore o progresso das habilidades consolidadas
            </div>
          </div>
        </CCardHeader>
        <CCardBody>
          <CCard>
            <CCardBody>
              <ConsolidatedFilter
                onChange={params => onChangeFilter(params)}
                onClearFilter={onClearFilter}
                userId={userId}
                isAdmin={isAdmin(userRole)}
              />
            </CCardBody>
          </CCard>

          {loading ? (
            <Loading />
          ) : data.length < 1 ? (
            <div className="text-center">
              Selecione ao menos o grupo <HiUserGroup /> para obter o resultado.
            </div>
          ) : data.applications?.length < 1 || data.abilities?.length < 1 ? (
            <div className="text-center">Nenhum resultado encontrado.</div>
          ) : (
            <div className="w-100">
              <div className="w-100">
                <div className="d-flex w-100 justify-content-end mt-3 mb-2">
                  <CButton
                    id="printBtn"
                    color="link"
                    className="text-muted p-0"
                    size="sm"
                    onClick={() =>
                      arrayToCSV(
                        getCSV(data.abilities),
                        "Acertos por Habilidade.csv"
                      )
                    }
                  >
                    <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para CSV
                  </CButton>
                  <span className="mx-2">|</span>
                  <CButton
                    id="printBtn"
                    color="link"
                    className="text-muted p-0"
                    size="sm"
                    onClick={() =>
                      elementToPDF("toPrint", "Acertos por Habilidade.pdf")
                    }
                  >
                    <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
                  </CButton>
                </div>
                <div className="w-100" id="toPrint">
                  <div className="management-1statistics layoutTabelaComparacao flex-column w-100 mb-4">
                    <div className="row">
                      <div className="chart w-100">
                        <Charts
                          legendY="Habilidade"
                          legendX="Acertos %"
                          type="horizontalbar"
                          title=""
                          data={{
                            labels:
                              data.abilities?.map((ability, index) =>
                                formatAbility(ability, true)
                              ) || [],
                            datasets: [
                              {
                                data: [
                                  ...(data.abilities?.map(ability =>
                                    getPercentage(ability.ability_id).toFixed(0)
                                  ) || []),
                                  100
                                ],
                                backgroundColor: [
                                  "rgba(255, 99, 132, 0.2)",
                                  "rgba(54, 162, 235, 0.2)",
                                  "rgba(255, 206, 86, 0.2)",
                                  "rgba(75, 192, 192, 0.2)",
                                  "rgba(153, 102, 255, 0.2)",
                                  "rgba(255, 159, 64, 0.2)",
                                  "rgba(255, 0, 41, 0.2)",
                                  "rgba(55, 126, 184, 0.2)",
                                  "rgba(102, 166, 30, 0.2)",
                                  "rgba(152, 78, 163, 0.2)",
                                  "rgba(0, 210, 213, 0.2)",
                                  "rgba(255, 127, 0, 0.2)",
                                  "rgba(254, 224, 182, 0.2)",
                                  "rgba(127, 128, 205, 0.2)",
                                  "rgba(179, 233, 0, 0.2)",
                                  "rgba(196, 46, 96, 0.2)"
                                ],
                                borderColor: [
                                  "rgba(255, 99, 132, 1)",
                                  "rgba(54, 162, 235, 1)",
                                  "rgba(255, 206, 86, 1)",
                                  "rgba(75, 192, 192, 1)",
                                  "rgba(153, 102, 255, 1)",
                                  "rgba(255, 159, 64, 1)",
                                  "rgba(255, 0, 41, 1)",
                                  "rgba(55, 126, 184, 1)",
                                  "rgba(102, 166, 30, 1)",
                                  "rgba(152, 78, 163, 1)",
                                  "rgba(0, 210, 213, 1)",
                                  "rgba(255, 127, 0, 1)",
                                  "rgba(254, 224, 182, 1)",
                                  "rgba(127, 128, 205, 1)",
                                  "rgba(179, 233, 0, 1)",
                                  "rgba(196, 46, 96, 1)"
                                ],
                                borderWidth: 1
                              }
                            ]
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="w-100" style={{ marginBottom: "40px" }}>
                    <table className="table table-hover table-outline mb-0 d-none d-sm-table acertosPorQuestao w-100">
                      <thead className="thead-light">
                        <tr>
                          <th>Habilidade</th>

                          <th>Acertos</th>

                          <th>% Acertos</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.abilities?.map((ability, index) => (
                          <tr key={index}>
                            <td>{formatAbility(ability)}</td>
                            <td className="">
                              {getCorrects(ability.ability_id)}
                            </td>
                            <td>
                              <div className="clearfix">
                                <div className="float-left">
                                  {getPercentage(ability.ability_id).toFixed(0)}
                                  %
                                </div>
                              </div>
                              <CProgress
                                className="progress-xs"
                                color={
                                  getPercentage(ability.ability_id).toFixed(0) >
                                  50
                                    ? "success"
                                    : getPercentage(ability.ability_id).toFixed(
                                        0
                                      ) <= 50 &&
                                      getPercentage(ability.ability_id).toFixed(
                                        0
                                      ) >= 30
                                    ? "warning"
                                    : "danger"
                                }
                                value={getPercentage(
                                  ability.ability_id
                                ).toFixed(0)}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </CCardBody>
        <ProtectedRoute routeId={props.currentRoute} />
      </CCard>
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConsolidatedPanel);
